import Config from 'common-src/config';

export const AthenaDepartment = {
  NeurologyDanvers: {
    id: 1,
    value: 'Neurology Danvers',
  },
  GUIDE: {
    id: 2,
    value: 'GUIDE',
  },
  NeurologyOrangeCounty: {
    id: Config.ATHENA_NEUROLOGY_ORANGE_COUNTY_DEPARTMENT_ID,
    value: 'Neurology Orange County',
  },
};

export const AthenaDepartmentsOptions = Object.values(AthenaDepartment).map((department) => ({
  label: department.value,
  value: department.value,
}));

export const AthenaPracticeOptions = [JSON.parse(Config.ATHENA_MINDSPAN_GROUP_PRACTICE)];
